import { DocumentManager } from "@features/rh/documents/components/DocumentManager";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { FileArchive } from "lucide-react";

export const Route = createFileRoute("/_app/rh/documents/")({
  loader: requirePermission(PERMISSIONS.RH.DOCUMENTS.VIEW),
  staticData: {
    title: "Documents",
    icon: FileArchive,
    tab_icon: FileArchive,
    permission: PERMISSIONS.RH.DOCUMENTS.VIEW,
    module: "rh",
    section: "Ressources Humaines",
    order: 24,
    showInNav: true,
    showInTab: true,
    showInBreadcrumb: true,
    description: "Gestion des Documents",
  },
  component: DocumentManager,
});
